const iconBuildPortfolio = require('assets/icons/icon-build-portfolio.svg');
const iconFondosESG = require('assets/icons/icon-fondos-esg.svg');
const alternativeFundsSideImage = require('assets/images/fondos-alternativos-banner-side.png');
const iconRise = require('assets/icons/icon-rise.svg');
const iconLiquidity = require('assets/icons/icon-liquidity-stars.svg');

const WEALTH_PRODUCT_BANNERS = {
    'warrants': {
        id: 'warrants',
        title: 'informationAboutProduct-warrantsTitle',
        sidebarImgAlt: 'informationAboutProduct-warrantsTitle',
        sidebarImgUrl: '', // Complete this when images are provided and delete comment
        subtitle: '',
        advantages: [
            // TODO: Currently using existing keys but to maintain consistancy for all productbanner can we rename keys in poeditor??
            {
                text: 'informationAboutProduct-invest',   //'bannerWarrants-advantage01',
                icon: 'icon-inversiones-ahorros',
                description: 'informationAboutProduct-investDescription'
            },
            {
                text: 'informationAboutProduct-multiply',   // 'bannerWarrants-advantage02',
                icon: 'icon-calcular',
                description: 'informationAboutProduct-multiplyDescription'
            },
            {
                text: 'informationAboutProduct-wideOffer',   // 'bannerWarrants-advantage03',
                icon: 'icon-diversificacion',
                description: 'informationAboutProduct-wideOfferDescription'
            },
            {
                text: 'informationAboutProduct-moreProducts',   // 'bannerWarrants-advantage04',
                icon: 'icon-mas-productos',
                description: 'informationAboutProduct-moreProductsDescription'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'cm': {
        id: 'cm',
        title: 'informationAboutProduct-titleCM',
        sidebarImgAlt: 'informationAboutProduct-titleCM',
        sidebarImgUrl: 'https://openbank.es/assets/static/private-assets/images/commercial-banners/fondos_inversion.jpg',
        subtitle: '',
        advantages: [
            {
                text: 'informationAboutProduct-firstColumnTitleCM',
                icon: iconFondosESG,
                iconType: 'SVG',
                description: 'informationAboutProduct-firstColumnDescriptionCM',
                link: 'informationAboutProduct-firstColumnLinkCMV2',
                linkText: 'informationAboutProduct-firstColumnLinkTextCM'
            },
            {
                text: 'informationAboutProduct-secondColumnTitleCM',
                icon: 'icon-rentabilidad',
                description: 'informationAboutProduct-secondColumnDescriptionCM',
                link: 'informationAboutProduct-secondColumnLinkCMV2',
                linkText: 'informationAboutProduct-secondColumnLinkTextCM'
            },
            {
                text: 'informationAboutProduct-thirdColumnTitleCM',
                icon: iconBuildPortfolio,
                iconType: 'SVG',
                description: 'informationAboutProduct-thirdColumnDescriptionCM',
                link: 'informationAboutProduct-thirdColumnLinkCMV2',
                linkText: 'informationAboutProduct-thirdColumnLinkTextCM'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'etfs': {
        id: 'etfs',
        title: 'informationAboutProduct-etfsTitle',
        sidebarImgAlt: 'informationAboutProduct-etfsTitle',
        sidebarImgUrl: '', // Complete this when images are provided and delete comment
        subtitle: '',
        advantages: [
            {
                text: 'informationAboutProduct-diversification',
                icon: 'icon-diversificacion',
                description: 'informationAboutProduct-diversificationDescription'
            },
            {
                text: 'informationAboutProduct-easyAccess',
                icon: 'icon-acciones-internacionales',
                description: 'informationAboutProduct-easyAccessDescription'
            },
            {
                text: 'informationAboutProduct-transparency',
                icon: 'icon-movil',
                description: 'informationAboutProduct-transparencyDescription'
            },
            {
                text: 'informationAboutProduct-strategy',
                icon: 'icon-contacto-whatsapp',
                description: 'informationAboutProduct-strategyDescription'
            }
        ],
        advantagesCollectivo: [
            {
                text: 'informationAboutProduct-diversification',
                icon: 'icon-diversificacion',
                description: 'informationAboutProduct-diversificationDescription'
            },
            {
                text: 'informationAboutProduct-easyAccess',
                icon: 'icon-inversiones-ahorros',
                description: 'informationAboutProduct-easyAccessDescription'
            },
            {
                text: 'informationAboutProduct-transparency',
                icon: 'icon-transparencia',
                description: 'informationAboutProduct-transparencyDescription'
            },
            {
                text: 'titleKey',
                icon: 'icon-estrategia',
                description: 'descriptionKey'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'funds': {
        id: 'funds',
        title: 'informationAboutProduct-pensionPlanTitle',
        sidebarImgAlt: 'informationAboutProduct-pensionPlanTitle',
        sidebarImgUrl: 'https://openbank.es/assets/static/private-assets/images/commercial-banners/fondos_inversion.jpg',
        subtitle: '',
        advantages: [
            {
                text: 'informationAboutProduct-profitability',
                icon: 'icon-rentabilidad',
                description: 'informationAboutProduct-profitabilityDescription'
            },
            {
                text: 'informationAboutProduct-easyToInvest',
                icon: 'icon-seguro-accidentes',
                description: 'informationAboutProduct-easyToInvestDescription'
            },
            {
                text: 'informationAboutProduct-flexibility',
                icon: 'icon-libertad-cambio',
                description: 'informationAboutProduct-flexibilityDescription'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'plans': {
        id: 'plans',
        title: 'informationAboutProduct-pensionPlanTitle',
        sidebarImgAlt: 'informationAboutProduct-pensionPlanTitle',
        sidebarImgUrl: 'https://openbank.es/assets/static/private-assets/images/commercial-banners/planes_de_pension.jpg',
        subtitle: '',
        advantages: [
            {
                text: 'informationAboutProduct-saveTax',
                icon: 'icon-beneficios-monetarios',
                description: 'informationAboutProduct-saveTaxDescription'
            },
            {
                text: 'informationAboutProduct-diversifyInvest',
                icon: 'icon-diversificacion',
                description: 'informationAboutProduct-diversifyInvestDescription'
            },
            {
                text: 'informationAboutProduct-saveRetirement',
                icon: 'icon-ahorra-dinero',
                description: 'informationAboutProduct-saveRetirementDescription'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'stocks': {
        id: 'stocks',
        title: 'informationAboutProduct-stocksTitle',
        sidebarImgAlt: 'informationAboutProduct-stocksTitle',
        sidebarImgUrl: '', // Complete this when images are provided and delete comment
        subtitle: '',
        advantages: [
            {
                text: 'informationAboutProduct-purchaseStocks',
                icon: 'icon-acciones-internacionales',
                description: 'informationAboutProduct-purchaseStocksDescription'
            },
            {
                text: 'informationAboutProduct-followMarkets',
                icon: 'icon-tiempo',
                description: 'informationAboutProduct-followMarketsDescription'
            },
            {
                text: 'informationAboutProduct-takeDecisions',
                icon: 'icon-documento',
                description: 'informationAboutProduct-takeDecisionsDescription'
            },
            {
                text: 'informationAboutProduct-easyToManage',
                icon: 'icon-movil',
                description: 'informationAboutProduct-easyToManageDescription'
            }
        ],
        advantagesCollectivo: [
            {
                text: 'titleKey',
                icon: 'icon-documento',
                description: 'descriptionKey'
            },
            {
                text: 'informationAboutProduct-purchaseStocks',
                icon: 'icon-acciones-internacionales',
                description: 'informationAboutProduct-purchaseStocksDescription'
            },
            {
                text: 'informationAboutProduct-followMarkets',
                icon: 'icon-tiempo',
                description: 'informationAboutProduct-followMarketsDescription'
            },
            {
                text: 'informationAboutProduct-easyToManage',
                icon: 'icon-movil',
                description: 'informationAboutProduct-easyToManageDescription'
            }
        ],
        link: '/myprofile/broker/explore'
    },
    'alternativeFunds': {
        id: 'alternative_funds',
        title: 'brokerAlternativeFunds-productBanner_title',
        sidebarImgUrl: alternativeFundsSideImage,
        advantages: [
            {
                text: 'brokerAlternativeFunds-productBanner_advantage1Title',
                icon: 'icon-s-mi-locacion',
                description: 'brokerAlternativeFunds-productBanner_advantage1Content'
            },
            {
                text: 'brokerAlternativeFunds-productBanner_advantage2Title',
                icon: iconRise,
                iconType: 'large-svg',
                description: 'brokerAlternativeFunds-productBanner_advantage2Content'
            },
            {
                text: 'brokerAlternativeFunds-productBanner_advantage3Title',
                icon: iconLiquidity,
                iconType: 'large-svg',
                description: 'brokerAlternativeFunds-productBanner_advantage3Content'
            },
        ],
        link: '/myprofile/broker/explore'
    }
};

module.exports = WEALTH_PRODUCT_BANNERS;
